import Config from '../../config';
import {GetCall} from '../helper'

const URLS = {
    "WHITEPAPER" : Config.BASE_API_URL + "/whitepaper",
}


export const GetWhitePaperData = async(data?:any) => {
    return await GetCall(URLS.WHITEPAPER, { ...data ,"application": 'website'}, Config.DEFAULT_HEADER)
}